// Google Tag Manager: sending data

$(function () {

  // carreer form
  const careerForm = document.getElementById('careerContactForm');
  if (careerForm) {
    careerForm.addEventListener('submit', function (event) {
      event.preventDefault();
      dataLayer.push({
        'event': 'ga.event',
        'eventData': {
          'category': 'Formular',
          'action': 'Kariera',
          'label': 'Odeslan',
          'value': 0
        }
      });
      careerForm.submit();
    });
  }

  // newsletter form
  const newsletterForm = document.getElementById('mc-embedded-subscribe-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function (event) {
      event.preventDefault();
      dataLayer.push({ 'event': 'ga.event', 'eventData': { 'category': 'Formular', 'action': 'Chci EUC Novinky', 'label': 'Odeslan', 'value': 0 } });
      newsletterForm.submit();
    });
  }

  // homepage block divisions
  $('.BlockDivisions .BlockAnchor').click(function(e){
    e.preventDefault();
    let name = $(this).parents('.BlockDivisions-col').find('.BlockDivisions-heading').text();
    let href = $(this).attr('href');

    dataLayer.push({ 'event': 'ga.event', 'eventData': { 'category': 'Homepage Cards', 'action': 'Click', 'label': name, 'value': 0 } });
    
    //setTimeout(() => {
      window.location.href = href;
    //}, 500);
  });

});
